import React, { useCallback, useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';

import '../../libs/bulma.min.css';

import { exportSelectAllQueues } from '../../services';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';
import QueueAgents from '../Queues/QueueAgents';
import QueueIdentifyOnHold from '../Queues/QueueIdentifyOnHold';
import QueueIdentifyAnswered from '../Queues/QueueIdentifyAnswered';
import StatsQueue from './components/Callcenter/QueueStats'

const ipGetRequest = window.location.href;
const myIP = ipGetRequest.split('/')[2].includes(':') ? ipGetRequest.split('/')[2].split(':')[0] : ipGetRequest.split('/')[2];
// const myIP = ipGetRequest.split('/')[2];

const socket = io(`http://${myIP}:3006/ws`);
// console.log(`http://${myIP}/ws`);
socket.on('connection', (evt) => console.log('CONN: ', evt))

function QueueList(queue) {
  const { queueName, queueRemove } = queue;
  
  let url = window.location.href;
  url = url.split('/')[2];
  // SEND DATA

  return (
    <div className="card column mb-2 is-half">
      <div className="card-title">
        <div className="media has-background-info has-text-justified">
          <div className="media-left ml-2 pt-1">
          <h1 className="has-text-justified"><button className="delete has-background-danger" aria-label="delete" onClick={ () => queueRemove(queueName) }> </button></h1>
          </div>
          <div className="media-content">
            <p className="title is-4 has-text-white">{ queueName }</p>
            <p className="subtitle is-6"></p>
          </div>
        </div>

        <div className="columns is-multiline">
        {/* {  typeof queuesParams[queueName] !== 'undefined' ? <StatsQueue queue={ queueName } socketio={ socket } /> : '' } */}
        {   <StatsQueue queue={ queueName } socketio={ socket } /> }
        <div className="column is-3">
            <h1 className="has-background-link-light has-text-centered"><strong>Espera</strong></h1>
            <table id="global" className="table is-hoverable is-striped is-fullwidth mt-1">
              <thead>
                <tr>
                  <th className="is-size-7 has-text-centered" scope="col">Tel.</th>
                  <th className="is-size-7 has-text-centered" scope="col">Tempo</th>
                </tr>
              </thead>
              <tbody>
                {
                  <QueueIdentifyOnHold queue={ queueName } socketio={ socket } />
                }
              </tbody>
            </table>
          </div>
          <div className="column">
            <h1 className="has-background-link-light has-text-centered"><strong>Em atendimento</strong></h1>
            <table id="global" className="table is-hoverable is-striped is-fullwidth mt-1">
              <thead>
                <tr>
                  <th className="is-size-7 has-text-centered" scope="col">Tel.</th>
                  <th className="is-size-7 has-text-centered" scope="col">Atend.</th>
                  <th className="is-size-7 has-text-centered" scope="col">Tempo</th>
                </tr>
              </thead>
              <tbody>
                {
                  <QueueIdentifyAnswered queue={ queueName } socketio={ socket } />
                }
              </tbody>
            </table>
          </div>
          {/* <div className="column">
            <h1 className="is-size-6 has-background-link-light has-text-centered"><strong>Atendentes</strong></h1>
            <table id="global" className="table is-hoverable is-striped is-fullwidth mt-1">
              <thead>
                  <tr>
                  <th className="is-size-7 has-text-centered" scope="col">Agente:</th>
                  <th className="is-size-7 has-text-centered" scope="col">Ramal:</th>
                  <th className="is-size-7 has-text-centered" scope="col">Pausa:</th>
                  <th className="is-size-7 has-text-centered" scope="col">Status:</th>
                  </tr>
              </thead>
              <tbody>
                {
                  Object.keys(agents).length > 0 ? Object.keys(agents).map((agent, index) => <QueueAgents key={ index } agent={ agents[agent] } />) : <tr><td></td></tr>
                }
              </tbody>
            </table>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default QueueList;